// commonRepo/features/user/userSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import { loginApi, registerApi } from "../../api/api"; 
import { AppDispatch } from "./types/types"; // Import AppDispatch type
import setCookie from "../../login/Setcookie";

const cookies = new Cookies();

interface ProfileData {
  id: string;
  name: string | null;
  mobile: string | null;
  email: string;
  address: string | null;
  roleType: number;
}

interface UserState {
  profileData: ProfileData | null;
  successMessage: string | null;
  errorMessage: string | null;
  isLoading: boolean;
}

const initialState: UserState = {
  profileData: null,
  successMessage: null,
  errorMessage: null,
  isLoading: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setProfileData: (state, action: PayloadAction<ProfileData>) => {
      state.profileData = action.payload;
    },
    clearProfileData: (state) => {
      state.profileData = null;
      state.successMessage = "Logged out successfully!";
      cookies.remove("authToken", { path: "/" });
      window.location.href = "/home";
    },
    setErrorMessage: (state, action: PayloadAction<string | null>) => {
      state.errorMessage = action.payload;
    },
    setSuccessMessage: (state, action: PayloadAction<string | null>) => {
      state.successMessage = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const {
  setProfileData,
  clearProfileData,
  setErrorMessage,
  setSuccessMessage,
  setLoading,
} = userSlice.actions;

export const loginUser =
  (url: string, email: string, password: string) =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await loginApi(url, email, password);
      if (response?.data?.token) {
        // cookies.set("authToken", response.data.token, { maxAge: 86400 });
        setCookie(response.data.token);
        console.log(response);
        dispatch(
          setProfileData({ ...response.data, token: response.data.token })
        );
        dispatch(setSuccessMessage("Login successful!"));
        window.location.href = "/home";
      } else {
        dispatch(setErrorMessage("Login failed. Please try again."));
      }
    } catch (error) {
      console.error("Error during login:", error);
      dispatch(setErrorMessage("An error occurred during login."));
    }
    dispatch(setLoading(false));
  }; 

export const registerUser =
  (
    url: string,
    name: string,
    email: string,
    mobile: string,
    confirmPassword: string
  ) =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await registerApi(
        url,
        name,
        email,
        mobile,
        confirmPassword
      );
      if (response) {
        // cookies.set("authToken", response, { maxAge: 86400 });
        setCookie(response.data.token);
        dispatch(setSuccessMessage("Registration successful!"));
        // window.location.href = "/home";
      } else {
        dispatch(setErrorMessage("Registration failed. Please try again."));
      }
    } catch (error) {
      console.error("Error during registration:", error);
      dispatch(setErrorMessage("An error occurred during registration."));
    }
    dispatch(setLoading(false));
  };
export default userSlice.reducer;
